export enum ENUM_DON_VI_HANH_CHINH {
    THANH_PHO = 1,
    QUAN_HUYEN = 2,
    PHUONG_XA = 3,
    DUONG = 4
}
